'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = require('../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# OhioLogoOutlineSVG
The Ohio State Bar Association logo outline
 */
var OhioLogoOutlineSVG = function OhioLogoOutlineSVG(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === undefined ? undefined : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? undefined : _ref$width,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? _config.colors.darkRed : _ref$color;
  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 242.82 248.71',
      'aria-label': 'OSBA Logo',
      role: 'img',
      height: height || undefined,
      width: width || undefined
    },
    _react2.default.createElement(
      'title',
      null,
      'OSBA Logo'
    ),
    _react2.default.createElement(
      'desc',
      null,
      'The Ohio State Bar Association logo'
    ),
    _react2.default.createElement('path', {
      fill: color,
      d: 'M172,131.15a66.56,66.56,0,0,0-.59-34.43h71.44V78.1H145.15l0,0H108.85c-.76,0-1.53-.07-2.3-.07a36,36,0,1,0,32.12,19.75l12.12-12.5a53.07,53.07,0,1,1-44.48-24.14c1.29,0,2.58.07,3.87.17H242.82V0C208.75,10.76,164.2,23.76,133.06,31.28,115,35.39,96.14,19.89,84.5,4.63H0V203.74l118.85,45,9.44-3.66V180.68a65.15,65.15,0,0,0,27.94-17.21v70.78l13-5,.1-61.06a15.82,15.82,0,0,1,31.63,0l-.1,48.84,13.23-5.12V161.41c0-8.7,6.69-16.3,15.4-16.54a15.75,15.75,0,0,1,13.34,6.76V131.15Z'
    })
  );
};

OhioLogoOutlineSVG.propTypes = {
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string,
  /** primary color for the logo */
  color: _propTypes2.default.string
};

OhioLogoOutlineSVG.displayName = 'OhioLogoOutlineSVG';

exports.default = OhioLogoOutlineSVG;
OhioLogoOutlineSVG.__docgenInfo = {
  'description': '# OhioLogoOutlineSVG\r\nThe Ohio State Bar Association logo outline',
  'methods': [],
  'displayName': 'OhioLogoOutlineSVG',
  'props': {
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    },
    'color': {
      'defaultValue': {
        'value': 'colors.darkRed',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'primary color for the logo'
    }
  }
};